// extracted by mini-css-extract-plugin
export default {"OptionContainer":"Star_OptionContainer__b+Ul2","Invalid":"Star_Invalid__Zd0MR"};